// extracted by mini-css-extract-plugin
export var bold = "_sg-0";